import { render, staticRenderFns } from "./Invoices.vue?vue&type=template&id=5d4d3d5f&lang=pug&"
import script from "./Invoices.vue?vue&type=script&lang=ts&"
export * from "./Invoices.vue?vue&type=script&lang=ts&"
import style0 from "./Invoices.vue?vue&type=style&index=0&id=5d4d3d5f&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports